const subAbas = [
  { label: 'Processos Jurídicos', rota: '/daf/procjur/processos' },
];

export default subAbas;
